/* Shoppius+ Produs — comportamentul paginii de produs (galerie, variante, coș, livrare, pachet, sticky). Date din [data-spp-data]. */
function sppInit() {
  var root = document.querySelector('[data-spp]');
  if (!root || root.__spp) return; root.__spp = true;
  var D = JSON.parse(root.querySelector('[data-spp-data]').textContent);
  var T = D.texts, $ = function (q, c) { return (c || root).querySelector(q); }, $$ = function (q, c) { return Array.prototype.slice.call((c || root).querySelectorAll(q)); };

  /* ── bani ── */
  function num(n, d, t, dec) { var s = (n / 100).toFixed(d), p = s.split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t); return p.length > 1 ? p[0] + dec + p[1] : p[0]; }
  function money(c) {
    c = Number(c) || 0;
    return D.money.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount': return num(c, 2, ',', '.');
        case 'amount_no_decimals': return num(c, 0, ',', '.');
        case 'amount_with_comma_separator': return num(c, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(c, 0, '.', ',');
        case 'amount_with_space_separator': return num(c, 2, ' ', ',');
        case 'amount_with_period_and_space': return num(c, 2, ' ', '.');
        default: return num(c, 2, '.', ',');
      }
    }).replace(/<[^>]*>/g, '');
  }
  function bigPrice(c) {
    var m = money(c).replace(/\s*(lei|ron|RON|Lei)\s*$/, ''), dec = m.slice(-2), int = m.slice(0, -3);
    return int + '<sup>' + dec + '</sup><small>' + D.currency + '</small>';
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ── galerie ── */
  var slides = $('[data-spp-slides]'), slideEls = $$('.spp__slide', slides), thumbs = $$('.spp__thumb'), countEl = $('[data-spp-count]');
  var prevB = $('[data-spp-prev]'), nextB = $('[data-spp-next]'), cur = 0;
  function goTo(i, smooth) {
    if (!slideEls.length) return;
    i = Math.max(0, Math.min(slideEls.length - 1, i));
    slides.scrollTo({ left: slideEls[i].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
    setCur(i);
  }
  function setCur(i) {
    cur = i;
    if (countEl) countEl.textContent = (i + 1) + ' / ' + slideEls.length;
    thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
    var th = thumbs[i]; if (th && th.parentNode) { var tp = th.parentNode; var l = th.offsetLeft - tp.clientWidth / 2 + th.clientWidth / 2; tp.scrollTo({ left: l, behavior: 'smooth' }); }
    if (prevB) prevB.disabled = i === 0;
    if (nextB) nextB.disabled = i === slideEls.length - 1;
    slideEls.forEach(function (s, k) { var v = s.querySelector('video'); if (v && k !== i) v.pause(); });
  }
  if (slides) {
    var st;
    slides.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(function () { var i = Math.round(slides.scrollLeft / slides.clientWidth); if (i !== cur) setCur(i); }, 60); }, { passive: true });
  }
  thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(+t.dataset.index); }); });
  if (prevB) prevB.addEventListener('click', function () { goTo(cur - 1); });
  if (nextB) nextB.addEventListener('click', function () { goTo(cur + 1); });
  setCur(0);

  /* ── lightbox ── */
  var lb = $('[data-spp-lb]'), lbImg = $('[data-spp-lb-img]'), lbStage = $('[data-spp-lb-stage]'), lbCount = $('[data-spp-lb-count]');
  var imgSlides = slideEls.filter(function (s) { return s.dataset.full; }), lbi = 0, lastFocus = null;
  function lbShow(i) {
    lbi = (i + imgSlides.length) % imgSlides.length;
    lbStage.classList.remove('is-zoom'); lbImg.style.transformOrigin = '';
    lbImg.src = imgSlides[lbi].dataset.full; lbCount.textContent = (lbi + 1) + ' / ' + imgSlides.length;
  }
  function lbOpen(slide) {
    if (!imgSlides.length) return;
    lastFocus = document.activeElement; lb.hidden = false; document.documentElement.style.overflow = 'hidden';
    lbShow(Math.max(0, imgSlides.indexOf(slide))); $('[data-spp-lb-close]').focus();
  }
  function lbClose() { lb.hidden = true; document.documentElement.style.overflow = ''; if (lastFocus) lastFocus.focus(); }
  imgSlides.forEach(function (s) { s.addEventListener('click', function () { lbOpen(s); }); });
  $('[data-spp-lb-close]').addEventListener('click', lbClose);
  $('[data-spp-lb-prev]').addEventListener('click', function (e) { e.stopPropagation(); lbShow(lbi - 1); });
  $('[data-spp-lb-next]').addEventListener('click', function (e) { e.stopPropagation(); lbShow(lbi + 1); });
  lbImg.addEventListener('click', function (e) {
    var r = lbImg.getBoundingClientRect();
    lbImg.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
    lbStage.classList.toggle('is-zoom');
  });
  var tx0 = null;
  lbStage.addEventListener('touchstart', function (e) { tx0 = e.touches[0].clientX; }, { passive: true });
  lbStage.addEventListener('touchend', function (e) { if (tx0 == null || lbStage.classList.contains('is-zoom')) return; var dx = e.changedTouches[0].clientX - tx0; if (Math.abs(dx) > 50) lbShow(lbi + (dx < 0 ? 1 : -1)); tx0 = null; });
  document.addEventListener('keydown', function (e) {
    if (lb.hidden) return;
    if (e.key === 'Escape') lbClose(); else if (e.key === 'ArrowLeft') lbShow(lbi - 1); else if (e.key === 'ArrowRight') lbShow(lbi + 1);
  });

  /* ── variante ── */
  var form = $('[data-spp-form]'), idIn = $('[data-spp-id]'), addB = $('[data-spp-add]'), addL = $('[data-spp-add-label]');
  var opts = $$('[data-spp-opt]');
  var V = D.variants, variant = V.filter(function (v) { return v.id === D.current; })[0] || V[0];
  var sel = variant.options.slice();
  function find(o) { return V.filter(function (v) { return v.options.every(function (x, i) { return x === o[i]; }); })[0]; }
  function markAvail() {
    opts.forEach(function (fs) {
      var pos = +fs.dataset.sppOpt;
      $$('.spp__val', fs).forEach(function (b) {
        var o = sel.slice(); o[pos] = b.dataset.val;
        var v = find(o), on = b.dataset.val === sel[pos];
        b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.classList.toggle('is-off', !v || !v.available);
      });
      var lab = $('[data-spp-opt-label]', fs); if (lab) lab.textContent = sel[pos];
    });
  }
  opts.forEach(function (fs) {
    var pos = +fs.dataset.sppOpt;
    fs.addEventListener('click', function (e) {
      var b = e.target.closest('.spp__val'); if (!b) return;
      sel[pos] = b.dataset.val;
      var v = find(sel);
      if (!v || !v.available) {
        var alt = V.filter(function (x) { return x.options[pos] === sel[pos] && x.available; })[0] || V.filter(function (x) { return x.options[pos] === sel[pos]; })[0];
        if (alt) { sel = alt.options.slice(); v = alt; }
      }
      if (v) setVariant(v, true);
    });
  });

  var priceEl = $('[data-spp-price]'), prpEl = $('[data-spp-prp]'), cmpEl = $('[data-spp-compare]'), saveEl = $('[data-spp-save]'), offEl = $('[data-spp-off]');
  var instEl = $('[data-spp-inst]'), instTx = $('[data-spp-inst-text]'), lowEl = $('[data-spp-low]'), stockEl = $('[data-spp-stock]');
  function setVariant(v, user) {
    variant = v; sel = v.options.slice();
    if (idIn) idIn.value = v.id;
    markAvail();
    priceEl.innerHTML = bigPrice(v.price);
    var hasCmp = v.compare > v.price;
    prpEl.hidden = !hasCmp; if (hasCmp) cmpEl.textContent = money(v.compare);
    var pct = hasCmp ? Math.round((v.compare - v.price) / v.compare * 100) : 0;
    if (saveEl) { saveEl.hidden = !hasCmp; if (hasCmp) saveEl.innerHTML = esc(T.save).replace('{procent}', pct).replace('{suma}', '<b>' + esc(money(v.compare - v.price)) + '</b>'); }
    if (offEl) { offEl.hidden = !hasCmp || pct < 1; offEl.textContent = '-' + pct + '%'; }
    if (instEl) { var ok = v.price >= D.inst.min && D.inst.count > 1; instEl.hidden = !ok; if (ok) instTx.textContent = T.inst.replace('{rate}', D.inst.count).replace('{suma}', money(Math.ceil(v.price / D.inst.count))); }
    $$('[data-spp-sku]').forEach(function (n) { n.textContent = v.sku || ''; });
    var sw = $('[data-spp-sku-wrap]'); if (sw) sw.hidden = !v.sku;
    addB.disabled = !v.available; addL.textContent = v.available ? T.add : T.soldout;
    if (lowEl) { var low = v.available && v.inv != null && v.inv > 0 && v.inv <= D.lowStock; lowEl.hidden = !low; if (low) lowEl.querySelector('span').textContent = T.low.replace('{n}', v.inv); }
    if (stockEl) { stockEl.classList.toggle('is-out', !v.available); stockEl.querySelector('span').textContent = v.available ? T.instock : T.outstock; }
    var eta = $('[data-spp-eta]'); if (eta) eta.hidden = !v.available;
    updateSticky();
    if (user) {
      if (v.media) { var idx = slideEls.findIndex(function (s) { return +s.dataset.mediaId === v.media; }); if (idx > -1) goTo(idx); }
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.toString()); } catch (e) {}
      updateBundleMain();
      document.dispatchEvent(new CustomEvent('shoppius:variant-change', { detail: { variant: v } }));
    }
  }

  /* ── cantitate ── */
  var qIn = $('[data-spp-qty-input]');
  $$('[data-spp-qty]').forEach(function (b) { b.addEventListener('click', function () { qIn.value = Math.max(1, Math.min(99, (parseInt(qIn.value, 10) || 1) + (+b.dataset.sppQty))); }); });

  /* ── adăugare în coș (deschide mini cart prin /cart/add.js) ── */
  var ferr = $('[data-spp-ferr]');
  function addItems(items, btn) {
    if (ferr) ferr.hidden = true;
    if (btn) { btn.disabled = true; btn.classList.add('is-busy'); }
    return fetch(D.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) { if (!window.ShoppiusCart) location.href = D.root + 'cart'; return j; })
      .catch(function (err) { var m = (err && (err.description || err.message)) || T.error; if (ferr) { ferr.textContent = m; ferr.hidden = false; } else alert(m); throw err; })
      .finally(function () { if (btn) { btn.classList.remove('is-busy'); btn.disabled = btn === addB ? !variant.available : false; } });
  }
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!variant.available) return;
    var q = Math.max(1, parseInt(qIn ? qIn.value : 1, 10) || 1);
    var items = [{ id: variant.id, quantity: q }];
    var war = $('[data-spp-war]');
    if (war && war.checked) { var it = { id: +war.value, quantity: q, properties: {} }; it.properties[D.warrantyProp || 'Pentru'] = D.title; items.push(it); }
    addItems(items, addB).catch(function () {});
  });
  $$('[data-spp-addid]').forEach(function (b) { b.addEventListener('click', function () { addItems([{ id: +b.dataset.sppAddid, quantity: 1 }], b).catch(function () {}); }); });

  /* ── livrare: ETA + countdown ── */
  var etaEl = $('[data-spp-eta]');
  function isOff(d) { var w = d.getDay(); return w === 0 || (w === 6 && !D.eta.saturday); }
  function addBiz(d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); if (!isOff(d)) n--; } return d; }
  function fmtD(d) { return d.toLocaleDateString('ro-RO', { weekday: 'short', day: 'numeric', month: 'short' }); }
  function renderEta() {
    if (!etaEl) return;
    var now = new Date(), cut = new Date(now); cut.setHours(D.eta.cutoff, 0, 0, 0);
    var shipToday = !isOff(now) && now < cut;
    var base = shipToday ? now : addBiz(now, 1);
    var a = addBiz(base, D.eta.min), b = addBiz(base, D.eta.max);
    var head;
    if (shipToday) { var ms = cut - now, h = Math.floor(ms / 3600000), m = Math.floor(ms % 3600000 / 60000); head = T.etaCount.replace('{timp}', '<b class="spp__cd">' + (h > 0 ? h + ' h ' : '') + m + ' min</b>').replace('{ora}', D.eta.cutoff + ':00'); }
    else head = T.etaNow.replace('{ora}', D.eta.cutoff + ':00');
    etaEl.innerHTML = head + ' ' + T.eta.replace('{min}', '<b>' + fmtD(a) + '</b>').replace('{max}', '<b>' + fmtD(b) + '</b>');
  }
  renderEta(); setInterval(renderEta, 30000);

  /* ── descriere pliabilă ── */
  var desc = $('[data-spp-desc]'), more = $('[data-spp-more]');
  if (desc && more) {
    var chk = function () { if (desc.classList.contains('is-clamp')) more.hidden = desc.scrollHeight <= desc.clientHeight + 40; };
    if (document.readyState === 'complete') chk(); else window.addEventListener('load', chk); chk();
    var lbl = more.textContent;
    more.addEventListener('click', function () { var open = desc.classList.toggle('is-clamp'); more.textContent = open ? lbl : more.dataset.less; if (open) desc.parentNode.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
    if (!desc.classList.contains('is-clamp')) more.hidden = true;
  }

  /* ── pachet „cumpărate împreună" ── */
  var bd = $('[data-spp-bundle]'), bdItems = [];
  function bdRender() {
    if (!bd) return;
    var imgs = $('[data-spp-bd-imgs]', bd), rows = $('[data-spp-bd-rows]', bd);
    var all = [{ main: true, title: D.title, url: D.url, image: variant.image || D.image, variants: [variant] }].concat(bdItems);
    imgs.innerHTML = all.map(function (it, i) { return (i ? '<span aria-hidden="true">+</span>' : '') + '<a href="' + esc(it.url) + '" data-bd-img="' + i + '">' + (it.image ? '<img src="' + esc(it.image) + '" alt="" loading="lazy">' : '') + '</a>'; }).join('');
    rows.innerHTML = all.map(function (it, i) {
      var v = it.main ? variant : (it.sel || it.variants.filter(function (x) { return x.available; })[0]);
      it.sel = v;
      var selHtml = '';
      if (!it.main && it.variants.length > 1) selHtml = '<select data-bd-sel="' + i + '" aria-label="Variantă">' + it.variants.map(function (x) { return '<option value="' + x.id + '"' + (x.id === v.id ? ' selected' : '') + (x.available ? '' : ' disabled') + '>' + esc(x.title) + '</option>'; }).join('') + '</select>';
      var chip = it.main && variant.title !== 'Default Title' ? '<span class="chip">' + esc(variant.title) + '</span>' : '';
      return '<div class="spp__bd-row"><input type="checkbox" data-bd-chk="' + i + '"' + (it.off ? '' : ' checked') + (it.main ? ' disabled checked' : '') + ' aria-label="Include ' + esc(it.title) + '">' +
        '<div class="t">' + (it.main ? '<b>' + esc(T.thisProduct) + '</b> ' : '') + (it.main ? esc(it.title) : '<a href="' + esc(it.url) + '">' + esc(it.title) + '</a>') + chip + '</div>' + (selHtml || '<span></span>') +
        '<div class="pr"><b>' + esc(money(v.price)) + '</b>' + (v.compare > v.price ? '<s>' + esc(money(v.compare)) + '</s>' : '') + '</div></div>';
    }).join('');
    bd.__all = all; bdTotal();
  }
  function bdTotal() {
    var all = bd.__all, t = 0, c = 0;
    all.forEach(function (it, i) { if (it.off) return; t += it.sel.price; c += Math.max(it.sel.compare, it.sel.price); var im = bd.querySelector('[data-bd-img="' + i + '"]'); if (im) im.classList.remove('is-off'); });
    all.forEach(function (it, i) { if (!it.off) return; var im = bd.querySelector('[data-bd-img="' + i + '"]'); if (im) im.classList.add('is-off'); });
    $('[data-spp-bd-total]', bd).textContent = money(t);
    $('[data-spp-bd-compare]', bd).textContent = c > t ? money(c) : '';
  }
  function updateBundleMain() { if (bd && !bd.hidden) bdRender(); }
  if (bd) {
    bd.addEventListener('change', function (e) {
      var t = e.target, all = bd.__all;
      if (t.dataset.bdChk) { all[+t.dataset.bdChk].off = !t.checked; bdTotal(); }
      if (t.dataset.bdSel) { var it = all[+t.dataset.bdSel]; it.sel = it.variants.filter(function (x) { return x.id === +t.value; })[0]; bdRender(); }
    });
    $('[data-spp-bd-add]', bd).addEventListener('click', function () {
      var items = bd.__all.filter(function (it) { return !it.off && it.sel && it.sel.available !== false; }).map(function (it) { return { id: it.sel.id, quantity: 1 }; });
      addItems(items, this).catch(function () {});
    });
    var data = []; try { data = JSON.parse($('[data-spp-bd-data]', bd).textContent); } catch (e) {}
    var src = bd.dataset.source;
    function fromRec(list) {
      return (list || []).filter(function (p) { return p.available && p.id !== D.productId; }).map(function (p) {
        return { title: p.title, url: p.url, image: p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '', variants: p.variants.map(function (v) { return { id: v.id, title: v.title, price: v.price, compare: v.compare_at_price || 0, available: v.available }; }) };
      });
    }
    function show(list) { bdItems = list.slice(0, D.bundleMax); if (!bdItems.length) return; bd.hidden = false; bdRender(); }
    if (src === 'metafield') show(data);
    else if (src !== 'off') {
      var get = function (intent) { return fetch(D.root + 'recommendations/products.json?product_id=' + D.productId + '&limit=' + (D.bundleMax + 2) + '&intent=' + intent).then(function (r) { return r.json(); }).then(function (j) { return fromRec(j.products); }); };
      get('complementary').then(function (l) { return l.length || src === 'complementary' ? l : get('related'); }).then(show).catch(function () {});
    }
  }

  /* ── bară sticky ── */
  var sticky = $('[data-spp-sticky]');
  function updateSticky() {
    if (!sticky) return;
    $('[data-spp-sticky-price]', sticky).textContent = money(variant.price);
    $('[data-spp-sticky-compare]', sticky).textContent = variant.compare > variant.price ? money(variant.compare) : '';
    var b = $('[data-spp-sticky-add]', sticky); b.disabled = !variant.available;
    $('[data-spp-sticky-label]', sticky).textContent = variant.available ? T.add : T.soldout;
  }
  if (sticky) {
    document.querySelectorAll('body > .spp__sticky').forEach(function (n) { if (n !== sticky) n.remove(); });
    document.body.appendChild(sticky);
    $('[data-spp-sticky-add]', sticky).addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(addB); else addB.click(); });
    var codB = $('[data-spp-sticky-cod]', sticky);
    codB.addEventListener('click', function () { var t = form.parentNode.querySelector('.osc-trigger'); if (t) t.click(); });
    var buy = $('.spp__buy');
    if ('IntersectionObserver' in window && buy) {
      new IntersectionObserver(function (en) {
        var e = en[en.length - 1], show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', show); sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        $$('button', sticky).forEach(function (x) { x.tabIndex = show ? 0 : -1; });
        var t = form.parentNode.querySelector('.osc-trigger'); codB.hidden = !t || t.hidden;
      }).observe(buy);
    }
  }

  /* ── poziție sub header-ul lipicios ── */
  var hdr = document.querySelector('.shoppius-header');
  function setTop() { var top = 0; if (hdr) { var r = hdr.getBoundingClientRect(); if (r.bottom > 0 && r.top > -2) top = Math.round(r.bottom); } root.style.setProperty('--spp-top', top + 'px'); }
  setTop(); window.addEventListener('scroll', function () { requestAnimationFrame(setTop); }, { passive: true });

  setVariant(variant, false);
}
sppInit();
document.addEventListener('shopify:section:load', sppInit);
